import * as tslib_1 from "tslib";
import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FieldType } from '../../../core';
var FormlyFieldCheckbox = (function (_super) {
    tslib_1.__extends(FormlyFieldCheckbox, _super);
    function FormlyFieldCheckbox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormlyFieldCheckbox.createControl = function (model, field) {
        return new FormControl({ value: model ? 'on' : undefined, disabled: field.templateOptions.disabled }, field.validators ? field.validators.validation : undefined, field.asyncValidators ? field.asyncValidators.validation : undefined);
    };
    return FormlyFieldCheckbox;
}(FieldType));
FormlyFieldCheckbox = tslib_1.__decorate([
    Component({
        selector: 'formly-field-checkbox',
        template: "\n    <label class=\"custom-control custom-checkbox\">\n      <input type=\"checkbox\" [formControl]=\"formControl\"\n        *ngIf=\"!to.hidden\" value=\"on\"\n        [formlyAttributes]=\"field\" class=\"custom-control-input\">\n        {{ to.label }}\n        <span class=\"custom-control-indicator\"></span>\n    </label>\n  ",
    })
], FormlyFieldCheckbox);
export { FormlyFieldCheckbox };
//# sourceMappingURL=checkbox.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-formly/lib/src/ui-bootstrap/src/types/checkbox.js
// module id = 772
// module chunks = 3